<template>
  <b-col xl="3">
    <div class="auth-full-page-content p-md-5 p-4">
      <div class="w-100">
        <div class="d-flex flex-column h-100">
          <login-header></login-header>
          <div class="my-auto">
            <div>
              <h5 class="text-primary">{{ $t('pages.login.welcome') }}</h5>
              <p class="text-muted">{{ $t('pages.login.sign_message') }}</p>
              <validation-error v-if="isAuthError" :error="authError"/>
            </div>

            <div class="mt-4">
              <form @keydown.enter="login">
                <b-form-group
                    class="mb-3"
                    id="input-group-1"
                    :label="$t('pages.login.email')"
                    label-for="input-1"
                >
                  <b-form-input
                      id="input-1"
                      v-model="email"
                      type="text"
                      :placeholder="$t('pages.login.enter_email')"
                      :class="{'is-invalid': submitted && $v.email.$error}"
                  ></b-form-input>
                  <div
                      v-if="submitted && $v.email.$error"
                      class="invalid-feedback"
                  >
                    <span v-if="!$v.email.required">
                      {{ $t('pages.login.validations.email_required') }}
                    </span>
                    <span v-if="!$v.email.email">
                      {{ $t('pages.login.validations.email_invalid') }}
                    </span>
                  </div>
                </b-form-group>
                <b-form-group
                    class="mb-3"
                    id="input-group-2"
                    :label="$t('pages.login.password')"
                    label-for="input-2"
                >
                  <b-form-input
                      id="input-2"
                      v-model="password"
                      type="password"
                      :placeholder="$t('pages.login.enter_password')"
                      :class="{'is-invalid': submitted && $v.password.$error}"
                  ></b-form-input>
                  <div
                      v-if="submitted && !$v.password.required"
                      class="invalid-feedback"
                  >
                    {{ $t('pages.login.validations.password_required') }}
                  </div>
                </b-form-group>

                <div class="form-check">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="remember-check"
                      v-model="rememberMe"
                  />
                  <label class="form-check-label" for="remember-check">
                    {{ $t('pages.login.remember_me') }}
                  </label>
                </div>

                <div class="mt-3 d-grid">
                  <b-button @click="login" variant="primary" :disabled="loading">
                    <b-spinner v-if="loading" small></b-spinner>
                    {{ $t('pages.login.login') }}
                  </b-button>
                </div>
                <br>
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i>
                  {{ $t('pages.login.forgot_password') }}
                </router-link>

              </form>
              <div class="mt-5 text-center">
                <p>
                  {{ $t('pages.login.no_account') }}
                  <router-link
                      to="/register"
                      class="fw-medium text-primary"
                  >
                    {{ $t('pages.login.signup') }}
                  </router-link>
                </p>
              </div>
            </div>
          </div>

          <login-footer></login-footer>
        </div>
      </div>
    </div>
  </b-col>
</template>
<script>
import {email, required} from "vuelidate/lib/validators";
import LoginFooter from "./LoginFooter";
import LoginHeader from "./LoginHeader";
import ValidationError from "../../../../components/widgets/ValidationError";

export default {
  name: "LoginForm",
  components: {ValidationError, LoginHeader, LoginFooter},
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      loading: false,
      rememberMe: false
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  methods: {
    async login() {
      this.submitted = true;
      this.isAuthError = false;
      this.authError = null

      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return
      } else {
        this.tryingToLogIn = true;
        // Reset the authError if it existed.
        this.authError = null;
        this.loading = true
        const vm = this
        await vm.$auth.login({
          data: {
            email: vm.email,
            password: vm.password,
          },
          staySignedIn: true
        }).then(function () {
          vm.$router.push({name: 'dashboard'})
          vm.tryingToLogIn = false;
          vm.isAuthError = false;
        }).catch(err => {
          vm.tryingToLogIn = false;
          vm.authError = err.data
          vm.isAuthError = true;
        }).finally(() => {
          this.loading = false
        })
      }
    },
  },
};
</script>
